import React from 'react';
import ExpenseTypeFormPage from './ExpenseTypeFormPage';

interface ShowAlerts {
  showAlert: (message: string, severity?: 'success' | 'info' | 'warning' | 'error') => void;
  showLoading: () => void;
  hideLoading: () => void;
}

const ExpenseTypeEdit: React.FC<ShowAlerts> = () => <ExpenseTypeFormPage mode="edit" />;

export default ExpenseTypeEdit;
